import React from "react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import { SVGAsset } from "res";
import { PrimaryButton, SecondaryButton } from "components/ui";
import { BCMSCurrency, useWorkflowStep } from "bcms-react";
import { getDefault, getWorkflowSteps } from "components/workflows/DepositACheckWorkflow";
import { useWorkflow, useRoute, useGlobalController } from "bcms-react"; 
import { Deposit } from "model";

import "./styles.css";
import "./mobile.css";

/**
 * @function DepositACheckConfirmationPage
 * @return {React.Component}
 * @param {STRING} amount - Sets the transaction amount.
 * @param {STRING} transactionId - Sets the transaction id.
 * @exported true
 * @description The main component for DepositACheckConfirmationPage
 */
export default function DepositACheckConfirmationPage(props) {
    const data = { ...getDefaultPageData(), ...props.data ?? {}};
    const deposit = data.deposit;

    const { goStep } = useWorkflow() ?? {};
    const navigate = useRoute();
    const globalController = useGlobalController();

    const onDepositAnotherCheckClick = evt => goStep(0, getDefault(globalController));
    const onViewDepositHistoryClick = evt => navigate("/depositHistory");

    return (
        <PageContainer className="deposit-a-check-confirmation-page">
            <PageContentView>
                <CenterContentContainer>
                    <div className="endorsement-instructions-container hide">
                        <p className="top-desc-text">Please endorse the back of the check as shown below:</p>
                        <b className="top-desc-bold-text">For mobile deposit only</b>
                        <i className="top-desc-cursive-text">[Your name here]</i>
                    </div>
                    <ContentHeaderView text="Deposit A Check" />
                    <div className="flex-container flex-horizontal align-top info-container">
                        <div className="set-width">
                            <SVGAsset id="InfoIcon" />
                        </div>
                        <div className="flex-width">
                            <p>Your check has been deposited.</p>
                        </div>
                    </div>
                    <div className="bottom-container">
                        <p>The check deposit transaction of { deposit.amount.format() } has completed.</p>
                        {/*<p>The transaction ID is { deposit.transactionID }.</p>*/}
                        <p>The transaction ID is { "XXXX" }.</p>
                        <p>What to do with your check:</p>
                        <ul className="list-text-container">
                            <li className="list-text">With a pencil, write "Deposited via Mobile", and today's date.</li>
                            <li className="list-text">Store your check in a secure location.</li>
                            <li className="list-text">After 7 days, verify your deposit and destroy the check.</li>
                        </ul>
                    </div>
                    <div className="flex-container flex-vertical button-container">
                        <PrimaryButton text="Deposit Another Check" dataPoint="Deposit_Confirm_Deposit_Another" onClick={ onDepositAnotherCheckClick } />
                        <SecondaryButton text="View Deposit History" dataPoint="Deposit_Confirm_Deposit_History" onClick={ onViewDepositHistoryClick } />
                    </div>
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
    )
}

export const getDefaultPageData = () => ({ 
    deposit: Deposit.init({})
})